export enum SpeedTestStatus {
	none = 'none',
	completed = 'completed',
	inProgressUpload = 'inProgressUpload',
	inProgressDownload = 'inProgressDownload',
	canceled = 'canceled',
}
